import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { LogserviceService } from '../logservice/logservice.service';
import { MsalService } from '@azure/msal-angular';
import Swal from 'sweetalert2/dist/sweetalert2.js';
// import { validateAddBookmarkRequest } from 'powerbi-models';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable({
  providedIn: 'root'
})
export class UserserviceService {

  
  user_roleid:any

  private backendUrl: string;

  constructor(private httpClient: HttpClient, private logService: LogserviceService,private authService: MsalService,public test:MsalService) {

    this.backendUrl = environment.apiURL;
  }


  public getUser(): Observable<any> {
    //return this.httpClient.po
    //this.logService.logMessage('message', 'debug');
    //console.log('loginattempt',localStorage.getItem('loginattempt'));
    if(localStorage.getItem('loginattempt') == '1'){
      console.log('loginattempt',localStorage.getItem('loginattempt'));
      localStorage.setItem('loginattempt','0');
    }else{
      localStorage.setItem('loginattempt','1');
    }
    return this.httpClient.get(this.backendUrl+'me?loginattempt='+localStorage.getItem('loginattempt')).pipe(catchError(this.handleError));

  }
  public getAllNavigationSetByrole(roleid): Observable<any> {
    return this.httpClient.get(this.backendUrl+'getAllNavigationSetByrole/'+roleid, httpOptions)

}

  public logout(): Observable<any> 
  {        
     return this.httpClient.get(this.backendUrl+"sessionEnd").pipe(catchError(this.handleError));
  }

  public getCreateObjectList():Observable<any>
  {
    return this.httpClient.get(this.backendUrl+"getCreateObjectsByUser").pipe(catchError(this.handleError));
  }

  private handleError(errorObj: HttpErrorResponse | any) {

    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if(errorObj.status === 401){
        Swal.fire({
          html: `
          <div style="text-align: center;">
            <img src="../../assets/images/warning.svg" class="animated-check" style="width: 50px; margin-bottom: 10px;">
            <span style="font-size: 16px;">You are an unauthorized user to view this page.</span>
          </div>
        `,
          icon: 'error',
          confirmButtonText: 'OK'
        }).then((result) => {
             sessionStorage.clear();
            // this.authService.logout(); 
            $('#logoutagentportal').trigger('click');
        });
      }
      else if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime. Userservice';
        // localStorage.clear();
        // sessionStorage.clear();
        this.authService.logout();
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
        console.log('handleError', errorObj.status);
        // localStorage.clear();
        // sessionStorage.clear();
        this.authService.logout();
      }
    }
    return throwError(errorMessage);
  }

  public isValidUser():Boolean{

   
    var token = sessionStorage.getItem("msal.idtoken");
    if (token != null) {
      var idToken = token.split('.');

      var msalToken = JSON.parse(atob(idToken[1]));
      var currentTime = Math.round((new Date()).getTime() / 1000);
      // console.log(currentTime);
      // console.log(msalToken.exp);
      if (msalToken.exp < currentTime) {
        return false;
      }
      else{
        return true;
      }
    }
    else 
    {
      return false;
    }
   

  }
}